import type { FC } from 'react';
import { useEffect, useState } from 'react';
import MarkdownIt from 'markdown-it';

interface IMarkdownProps {
  path: string;
}

export const Markdown: FC<IMarkdownProps> = ({ path }) => {
  const [markdown, setMarkdown] = useState<string>('');

  const md = new MarkdownIt({ html: true });

  useEffect(() => {
    fetch(path)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        setMarkdown(text);
      });
  }, [path]);

  const renderMarkdown = (source: string) => {
    return md.render(source).replace(/(src|href)="\/([^"]+)"/g, `$1="${__PUBLIC_PATH__}$2"`);
  };

  return <span dangerouslySetInnerHTML={{ __html: renderMarkdown(markdown) }} />;
};
